export default __webpack_public_path__ + "static/media/funeralrites.167e76c5.png";